module.exports = __webpack_public_path__ + "img/img2-5.48982daa.png";